import { FC } from 'react';
import { Descriptions } from 'antd';

interface HealthProfessionViewProps {
  label?: string;
  title?: string | React.ReactNode;
  layout?: 'vertical' | 'horizontal';
  extra?: React.ReactNode;
  style?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  displayValueOnly: boolean;
  healthProfessionName: string | null;
}
export const HealthProfessionView: FC<HealthProfessionViewProps> = (props) => {
  return (
    <>
      {props.displayValueOnly ? (
        props.healthProfessionName
      ) : (<div>
        <Descriptions>
          title={props.title}
          layout={props.layout}
          extra={props.extra} 
            <Descriptions.Item label={props.label ?? 'Health Profession'} >{props.healthProfessionName}</Descriptions.Item>
        </Descriptions>
        </div>
      )}
    </>
  )
}


